import { motion } from "framer-motion";
import {
  TrendingUp,
  Palette,
  Globe,
  BrainCircuit,
  Smartphone,
  ArrowUpRight,
} from "lucide-react";
import { waLink, WA_MESSAGES } from "../lib/whatsapp";

const services = [
  {
    id: "trafego",
    icon: TrendingUp,
    title: "Tráfego Pago",
    desc: "Campanhas que convertem clique em cliente e escala em resultado.",
    msg: WA_MESSAGES.trafego,
  },
  {
    id: "design",
    icon: Palette,
    title: "Design",
    desc: "Identidade visual e criativos que fazem sua marca ser lembrada.",
    msg: WA_MESSAGES.design,
  },
  {
    id: "web",
    icon: Globe,
    title: "Web",
    desc: "Sites e landing pages de alta performance, feitos para converter.",
    msg: WA_MESSAGES.web,
  },
  {
    id: "ia",
    icon: BrainCircuit,
    title: "Inteligência Artificial",
    desc: "Automações e agentes de IA que colocam seu negócio à frente.",
    msg: WA_MESSAGES.ia,
  },
  {
    id: "apps",
    icon: Smartphone,
    title: "Apps",
    desc: "Aplicativos nativos e PWA, do primeiro rascunho ao launch.",
    msg: WA_MESSAGES.apps,
  },
];

const Services = () => (
  <section id="servicos" className="relative py-20 sm:py-28">
    <div className="mx-auto max-w-6xl px-5">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.15 }}
        transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        className="mb-12 flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between"
      >
        <div>
          <p className="mb-3 flex items-center gap-3 font-display text-[11px] font-bold uppercase tracking-[0.35em] text-brand-neon">
            <span className="h-px w-8 bg-brand-neon/60" />
            O que fazemos
          </p>
          <h2 className="font-display text-3xl font-extrabold tracking-tight sm:text-4xl">
            Escolha o serviço e fale
            <br className="hidden sm:block" /> direto com a gente.
          </h2>
        </div>
      </motion.div>

      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {services.map((s, i) => (
          <motion.a
            key={s.id}
            href={waLink(s.msg)}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={`service-card-${s.id}-whatsapp-button`}
            initial={{ opacity: 0, y: 34 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 0.7, delay: i * 0.08, ease: [0.16, 1, 0.3, 1] }}
            className={`group glass relative flex flex-col justify-between overflow-hidden rounded-3xl p-6 transition-colors duration-300 hover:border-brand-neon/50 sm:p-7 ${
              i === 0 ? "sm:col-span-2 lg:col-span-1" : ""
            } ${i === 4 ? "lg:col-span-2" : ""} hover:shadow-[0_0_35px_rgba(168,85,247,0.25)]`}
          >
            <div>
              <div className="mb-6 flex items-center justify-between">
                <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-brand/15 text-brand-neon ring-1 ring-brand-neon/25 transition-colors duration-300 group-hover:bg-brand group-hover:text-paper">
                  <s.icon className="h-5 w-5" strokeWidth={2.2} />
                </span>
                <span className="font-display text-xs font-bold tracking-[0.3em] text-mist/60">
                  0{i + 1}
                </span>
              </div>
              <h3 className="font-display text-xl font-bold">{s.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-mist">{s.desc}</p>
            </div>
            <span className="mt-6 inline-flex items-center gap-1.5 text-xs font-semibold uppercase tracking-[0.2em] text-brand-neon">
              Conversar no WhatsApp
              <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
            </span>
            <span className="pointer-events-none absolute -right-10 -top-10 h-28 w-28 rounded-full bg-brand-neon/0 blur-2xl transition-colors duration-500 group-hover:bg-brand-neon/20" />
          </motion.a>
        ))}

        <motion.div
          initial={{ opacity: 0, y: 34 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.15 }}
          transition={{ duration: 0.7, delay: 0.4, ease: [0.16, 1, 0.3, 1] }}
          className="flex flex-col justify-between rounded-3xl bg-brand p-6 sm:p-7"
        >
          <div>
            <h3 className="font-display text-xl font-bold text-paper">
              Não sabe por onde começar?
            </h3>
            <p className="mt-2 text-sm leading-relaxed text-paper/70">
              A gente diagnostica seu negócio e monta a estratégia ideal.
            </p>
          </div>
          <a
            href={waLink(WA_MESSAGES.general)}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="service-card-general-whatsapp-button"
            className="mt-6 inline-flex w-max items-center gap-1.5 rounded-full bg-ink px-5 py-2.5 text-xs font-bold uppercase tracking-[0.2em] text-paper transition-transform duration-300 hover:scale-105 active:scale-95"
          >
            Diagnóstico gratuito
            <ArrowUpRight className="h-4 w-4" />
          </a>
        </motion.div>
      </div>
    </div>
  </section>
);

export default Services;
